import React, { useState } from 'react';
import { Section } from './Section';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    q: '¿Es discreto el pago?',
    a: 'Sí, el cargo aparecerá como una compra educativa genérica.'
  }, {
    q: '¿Tengo que dejar de tener sexo estos 22 días?',
    a: 'No, pero aprenderás a tenerlo bajo una nueva estructura de control.'
  }, {
    q: '¿Funciona si soy mayor de 50 años?',
    a: 'Absolutamente, el sistema nervioso mantiene su capacidad de aprendizaje (neuroplasticidad) a cualquier edad.'
  }, {
    q: '¿Necesito comprar equipo especial?',
    a: 'No, solo el manual y 15 minutos de privacidad al día.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section darker data-id="element-38">
      <h2 className="font-display font-bold text-3xl md:text-5xl mb-12 text-center uppercase tracking-tight" data-id="element-39">
        Preguntas Frecuentes
      </h2>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-40">
        {faqs.map((faq, index) => <div key={index} className="border border-brand-gray/30 bg-brand-gray/10" data-id="element-41">
            <button className="w-full text-left px-6 py-5 flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-42">
              <span className="font-display font-bold text-lg md:text-xl uppercase" data-id="element-43">
                {faq.q}
              </span>
              <ChevronDown className={`w-6 h-6 text-brand-blue transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-44" />
            </button>
            <AnimatePresence data-id="element-45">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} className="overflow-hidden" data-id="element-46">
                  <div className="px-6 pb-5 text-gray-400 text-lg" data-id="element-47">{faq.a}</div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}